import React from 'react';
import { Link } from 'react-router-dom';
import CategoryPills from './CategoryPills.js';

import '../styles/pageBanner.css';

const PageBanner = ({
    crumbLabel,
    title,
    description,
    icon = null,
    search,
    searchPlaceholder = "Search",
    onSearchChange,
    selectedCategories,
    onCategoriesChange,
    showAllPill = false,
    sortCategories = false
}) => {
    return (
        <div className="page-banner">
            { icon && (
                <span
                    className="watermark"
                    style={{
                        maskImage: `url(${process.env.PUBLIC_URL}/assets/icons/categories/${icon}.svg)`
                    }}
                />
            ) }

            <nav className="crumbs">
                <Link to="/">Home</Link>
                <span className="separator">/</span>
                <span className="current">{crumbLabel}</span>
            </nav>

            { title && (
                <h1 className="title">{title}</h1>
            )}

            { description && (
                <p className="description">{description}</p>
            )}

            { onSearchChange && (
                <div className="filters">
                    <div className="search">
                        <span
                            className="icon"
                            style={{ maskImage: `url(${process.env.PUBLIC_URL}/assets/icons/search.svg)` }}
                        />
                        <input
                            type="search"
                            autoComplete="off"
                            placeholder={searchPlaceholder}
                            value={search}
                            onChange={event => onSearchChange(event.currentTarget.value)}
                        />
                    </div>

                    <CategoryPills
                        selected={selectedCategories}
                        onChange={onCategoriesChange}
                        showAllPill={showAllPill}
                        sortCategories={sortCategories}
                    />
                </div>
            ) }
        </div>
    );
};

export default PageBanner;
